import { apiFetch } from './api';

export function getStripeSubscriptionStatus() {
  return apiFetch('getSubscriptionStatus').then((res) => res.subscription || null);
}

export function createStripeCheckoutSession(payload) {
  return apiFetch('createSubscriptionCheckoutSession', {
    method: 'POST',
    body: JSON.stringify(payload || {}),
  }).then((res) => ({
    url: res.url || null,
    id: res.sessionId || null,
    trialApplied: Boolean(res.trialApplied),
  }));
}

export function createStripePortalSession(payload) {
  return apiFetch('createBillingPortalSession', {
    method: 'POST',
    body: JSON.stringify(payload || {}),
  }).then((res) => ({
    url: res.url || null,
  }));
}

export function getStripeCheckoutSessionStatus(sessionId) {
  return apiFetch('getCheckoutSessionStatus', {
    method: 'POST',
    body: JSON.stringify({ session_id: sessionId }),
  });
}
